import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Card, Steps } from 'antd';
import useService from '@/lib/hooks/useService';
import ArrangeCarButtonWithModal from '../ArrangeCarButtonWithModal';
import { ReservationContext } from '../UpdateProcessButtonWithModal';
import styles from './index.module.scss';
import type { CarServiceReservation } from '@/types/database/carService';

const { Step } = Steps;
const stepTitles = ['已安排', '抵達社區', '已上車', '抵達目的地'];

const ProcessSteps = () => {
  const { key: reservationId } = useContext(ReservationContext);

  const [reservation] = useService<CarServiceReservation>({
    collectionName: 'carService',
    query: { _id: reservationId },
  });

  const getCurrentProcess = useCallback(() => {
    if (reservation === undefined) {
      return 0;
    } else {
      switch (reservation[0]?.status) {
        case '已預約':
          return 0;
        case '已安排':
          return 1;
        case '車輛已抵達':
          return 2;
        case '已上車':
          return 3;
        default:
          return 4;
      }
    }
  }, [reservation]);

  useEffect(() => {
    setCurrentProcess(getCurrentProcess());
  }, [getCurrentProcess, reservation]);

  const [currentProcess, setCurrentProcess] = useState<number>(
    getCurrentProcess()
  );

  return (
    <Steps direction="vertical" size="small" current={currentProcess}>
      {stepTitles.map((step, index) => {
        return (
          <Step
            key={step}
            title={step}
            description={
              currentProcess === index ? (
                <Card
                  type="inner"
                  title={<div className={styles.cardTitle}>操作</div>}
                >
                  <ArrangeCarButtonWithModal />
                </Card>
              ) : null
            }
          />
        );
      })}
    </Steps>
  );
};

export default ProcessSteps;
